"use strict";
/**
 * Social Domain Database Types
 *
 * Follow and Favorite records — previously inline (no named types).
 * These types represent the actual DynamoDB records as written by lambda-secure.
 */
Object.defineProperty(exports, "__esModule", { value: true });
